<template>
  <div class="max-w-lg w-full mx-auto px-4">
    <div class="flex flex-wrap space-y-4 md:space-y-0">
      <div class="mt-8 mx-auto max-w-7xl sm:mt-20">
        <div
          :class="`
            ${
              organiserName === 'Birkbeck University of London'
                ? 'text-left'
                : 'text-center'
            }
          `"
        >
          <h1 class="text-3xl tracking-tight font-black text-primary text-left">
            <span class="block text-primary">Register for your free</span>
            <span class="block">GraduationClip</span>
          </h1>
          <p
            class="mt-3 max-w-md mx-auto text-primary text-lg md:max-w-3xl text-left font-extrabold"
          >
            <b>Congratulations</b> on graduating from
            <span v-if="organiserName == 'University of Sheffield'">the </span
            >{{ organiserName }}.
          </p>
          <p class="mt-3 text-base text-gray-500 md:mt-5 text-left font-medium">
            Register here for your free GraduationClip
            <span v-if="organiserName == 'Queen\'s University Belfast'"
              >- please use your personal email address to register.</span
            >
          </p>
          <p
            v-if="organiserName == 'Royal Holloway University of London'"
            class="mt-3 text-base text-gray-500 text-left font-mediuml"
          >
            Your personalised GraduationClip is a gift from the Royal Holloway
            Alumni Engagement Team and is the perfect way to share your big
            moment centre stage with the world.
          </p>

          <p v-else class="mt-3 text-base text-gray-500 text-left font-medium">
            Your personalised GraduationClip has been funded by
            <span v-if="organiserName == 'University of Sheffield'">the </span>
            {{ organiserName }} and is the perfect gift to share your big moment
            centre stage with the world.
          </p>
          <div class="flex justify-center">
            <button
              type="submit"
              @click="$emit('submit', form)"
              class="inline-flex w-full mt-6 justify-center items-center px-4 py-2 border border-blue-500 shadow-sm text-base font-extrabold rounded-md text-white bg-blue-500 hover:bg-blue-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Continue
            </button>
          </div>

          <p class="mt-6 text-base text-gray-500 text-left">
            <span v-if="organiserName == 'Royal Holloway University of London'">
              Your details will be shared with Royal Holloway’s Alumni
              Engagement Team to personalise your graduate experience and keep
              you informed about relevant news and opportunities.
              <a
                href="https://www.royalholloway.ac.uk/about-us/our-alumni/for-alumni/data-protection-and-privacy/"
                class="text-gray-700 font-medium underline"
              >
                Click Here for Privacy Notice
              </a>
            </span>

            <span v-else>
              <span v-if="organiserName == 'University of Leeds'">
                Your details will be passed on to the Alumni team at the
                University to provide you with event invites, alumni and
                department news relevant to you. You can view the Alumni privacy
                notice
                <a
                  href="http://www.leeds.ac.uk/alumni/doc/alumni-privacy-notice"
                  class="text-gray-700 font-medium underline"
                >
                  here
                </a>
                <a
                  href="http://www.leeds.ac.uk/alumni/doc/alumni-privacy-notice"
                  class="text-gray-700 font-medium underline"
                >
                  (http://www.leeds.ac.uk/alumni/doc/alumni-privacy-notice) </a
                >.
              </span>

              <span v-else>
                Your details will be passed on to the
                <span v-if="organiserName == 'Newcastle University'"
                  >Newcastle University Careers Service and your Academic School</span
                >
                <span v-else-if="organiserName == 'University of Sheffield'"
                  >Alumni Relations & Campaigns team</span
                >
                <span v-else>Alumni Office</span>, who will hold your details to
                personalise your graduate experience.
              </span>
              <br />

              For information on how MyGraduationClip will use your details
              please see our privacy statement
              <b>
                <a
                  href="https://app.mygraduationclip.com/privacy-policy/"
                  class="text-black underline font-medium"
                >
                  here
                </a> </b
              >.
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TitlePage",
  props: { title: String, organiserName: String },
  data: function () {
    return {
      form: {
        name: "",
      },
    };
  },
  methods: {
    submit() {
      this.$emit("submit", this.form);
    },
  },
};
</script>
